module.exports = __webpack_public_path__ + "static/media/batta.318b438a.jpg";